import App from 'srs.sharedcomponents/lib/esm/App'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import {
  ApplicationInsights,
  IPageViewTelemetry,
} from '@microsoft/applicationinsights-web'
import { env } from 'srs.sharedcomponents/lib/esm/api/env'
import { store } from 'srs.sharedcomponents/lib/esm/redux/store'
import { uuidv4 } from 'srs.sharedcomponents/lib/esm/utils/helpers'
import axios, { AxiosResponse } from 'axios'
import RouterProvider from 'srs.sharedcomponents/lib/esm/components/context/router/RouterProvider'
import routerConfig from 'srs.sharedcomponents/lib/esm/components/config/routes'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import { i18nNamespaces as namespace } from 'srs.sharedcomponents/lib/esm/i18n/i18n'
import coreSrsPrimaryOverride from './i18n/coreSrsPrimaryOverride.json'
import {
  bearerToken,
  selectIsAccountNotAssociatedPopupOpen,
  setAccountNotAssociatedPopupOpened,
} from 'srs.sharedcomponents/lib/esm/redux/slices/userSlice'
import {
  selectIsValidCustomerStatus,
  isGetPreferencesLoaded,
} from 'srs.sharedcomponents/lib/esm/redux/slices/prefferencesSlice'
import {
  useAppDispatch,
  useAppSelector,
} from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { BusinessRegion } from 'srs.sharedcomponents/lib/esm/utils/enums'
import { useTranslate } from 'srs.sharedcomponents/lib/esm/hooks/useTranslate'
import { useHistory } from 'react-router-dom'
interface IAppWrapper {
  appInsights: ApplicationInsights
}

const AppWrapper = ({ appInsights }: IAppWrapper) => {
  const location = useLocation()
  const { translate } = useTranslate()
  const dispatch = useAppDispatch()
  const { i18n } = useTranslation()
  const userLoggedIn = !!useAppSelector(bearerToken)
  const isPreferencesLoaded = !!useAppSelector(isGetPreferencesLoaded)
  const userHasValidAccount = !!useAppSelector(selectIsValidCustomerStatus)
  const region = useAppSelector((state) => state.user?.user?.region?.shortName)
  const history = useHistory()
  const accountPromptPopUpOpened = !!useAppSelector(
    selectIsAccountNotAssociatedPopupOpen,
  )
  Object.entries(coreSrsPrimaryOverride).forEach(([locale, entity]) => {
    Object.entries(entity).forEach(([key, value]) => {
      if (typeof value === 'string') {
        i18n.addResource(locale, namespace.coreSrsPrimary, key, value)
      } else {
        console.error(
          `Value for key '${key}' in locale '${locale}' is not a string:`,
          value,
        )
      }
    })
  })
  useEffect(() => {
    const myRequestInterceptor = axios.interceptors.request.use((request) => {
      const { method, url, headers } = request

      if (request.headers) {
        request.headers['X-Correlation-Id'] = uuidv4()
      }
 if (store.getState().user.user?.token) {
    const token: string | undefined =
      store.getState().user.user?.token

    if (token && request.headers)
      request.headers.Authorization = `Bearer ${token}`
  } else if (store.getState().welcome.welcome?.anonymousId) {
    const token: string | undefined =
      store?.getState().welcome.welcome?.anonymousId

    if (token && request.headers)
      request.headers.Authorization = `${token}`
  }
      if (request) {
        appInsights.trackEvent({
          name: 'API Request Ford Special tools',
          properties: {
            ApplicationName: 'Ford Special tools',
            RequestPath: url ?? '',
            Method: method ?? '',
            CorrelationId: headers ? headers['X-Correlation-Id'] : '',
          },
        })
      }

      return request
    })

    return () => {
      axios.interceptors.request.eject(myRequestInterceptor)
    }
  }, [])
  useEffect(() => {
    const myResponseInterceptor = axios.interceptors.response.use(
      (response: AxiosResponse) => {
        const { config, status, statusText } = response
        const { method, url, headers } = config

        if (config) {
          appInsights.trackEvent({
            name: 'API Response Ford Special tools',
            properties: {
              ApplicationName: 'Ford Special tools',
              RequestPath: url ?? '',
              Method: method ?? '',
              CorrelationId: headers ? headers['X-Correlation-Id'] : '',
              StatusCode: status,
              StatusCodeText: statusText,
            },
          })
        }

        return response
      },
      (error) => {
        // You can also log the error details in case of request failure
        appInsights.trackEvent({
          name: 'API Error',
          properties: {
            message: error.message,
            // Additional properties as needed
          },
        })

        return Promise.reject(new Error(error))
      },
    )

    return () => {
      axios.interceptors.response.eject(myResponseInterceptor)
    }
  }, [])

  useEffect(() => {
    if (!isPreferencesLoaded) return
    if (!userLoggedIn) {
      dispatch(setAccountNotAssociatedPopupOpened(false))
      return
    }
    if (userHasValidAccount) return
    if (accountPromptPopUpOpened) return

    Swal.fire({
      title: `${translate('txtAccountNotAssociated')}`,
      html: `
        <p>
         ${translate('msgAccountNotAssociated')}
        </p>
      `,
      icon: 'info',
      showDenyButton: true,
      confirmButtonText: translate('XpNotificationPopupOk'),
      denyButtonText: translate('DealerAssociationRemindMeText'),
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: 'swal-handle-approval-action',
        confirmButton: 'swal-custom-confirm-button',
        denyButton: 'swal-custom-deny-button',
      },
      didOpen: (popup) => {
        popup.id = 'account-association-popup'

        const confirmButton = popup.querySelector('.swal2-confirm')
        const denyButton = popup.querySelector('.swal2-deny')

        if (confirmButton) {
          confirmButton.id = 'account-association-ok-button'
        }
        if (denyButton) {
          denyButton.id = 'account-association-remind-button'
        }
      },
    }).then((result: { isConfirmed: any; isDenied: any }) => {
      if (result.isConfirmed) {
        // OK → redirect
        history.push('/contactus')
      }

      if (result.isDenied) {
        // Remind Me Later (session only)
        dispatch(setAccountNotAssociatedPopupOpened(true))
      }
    })
  }, [isPreferencesLoaded, userLoggedIn, region])

  useEffect(() => {
    const pageInfo: IPageViewTelemetry = {
      name: location?.pathname,
      uri: window?.location.href,
      isLoggedIn: !!store.getState().user?.user?.token,
    }
    if (env.APPLICATIONINSIGHTS_CONNECTION_STRING) {
      appInsights.trackPageView(pageInfo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <RouterProvider routesConfig={routerConfig}>
      <App />
    </RouterProvider>
  )
}

export default AppWrapper
